namespace Matrix.Data {
    export class AccountRoleColumns {
        static columnsKey = 'Data.AccountRole';
    }
}
